module.exports = __webpack_public_path__ + "media/src/img/telegram-icon-e208abb3e83ffd017d725bd069f23dcd.svg";